module.exports = __webpack_public_path__ + "gi.866228eceb28a8f8e2fd.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/gi.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/gi.svg
// module chunks = styles